import React from 'react';
import CircularProgress from '../circular-progress/CircularProgress';
import './Loader.scss';

const Loader = ({ text, size = 48, color = 'orange', ...props }) => {
  return (
    <div className="loader">
      <CircularProgress size={size} color={color} {...props} />
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
};

export default Loader;
